export default __webpack_public_path__ + "static/media/volume.cfbd7b81.svg";